import axios from 'axios';

// Compose API base from env and always target the /api namespace
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true, // include cookies if backend sets them
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;